import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportMemberTransactionPageRoutingModule } from './report-member-transaction-routing.module';

import { ReportMemberTransactionPage } from './report-member-transaction.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportMemberTransactionPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [ReportMemberTransactionPage]
})
export class ReportMemberTransactionPageModule {}
